import React, { useState, useRef, useEffect } from "react";
import SearchInput from "../SearchInput";
import StoreTable from "../StoreTable";
import Pagination from "../Pagination";
import DiscountDialog from "../DiscountDialog";
import { getAllShops, getAccessData } from "../../api/api";

export default function StoreSearch() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);

  const [search, setSearch] = useState("");
  const [openIndex, setOpenIndex] = useState(null);
  const [showDiscount, setShowDiscount] = useState(false);
  const [currentStore, setCurrentStore] = useState(null);
  const [discountPct, setDiscountPct] = useState("");
  const [page, setPage] = useState(1);

  const popoverRefs = useRef([]);

  useEffect(() => {
    fetchStores(search);
  }, [page]);

  const fetchStores = async (value) => {
    try {
      if (value === "") setLoading(true);
      const response = await getAllShops(page, value);
      if (response.status === 'success') {
        setStores(response.data);
        setTotalPages(response.totalPages);
        setTotalUsers(response.totalUsers);
      }
    } catch (error) {
      console.error('Error fetching stores:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDiscount = (store, idx) => {
    setCurrentStore(store);
    setShowDiscount(true);
    setDiscountPct("");
    setOpenIndex(null);
  };

  const handleAccessApp = async (store) => {
    try {
      const response = await getAccessData(store._id);
      if (response.status === 'success') {
        const userData = {
          id: store._id,
          email: store.email,
          shopName: store.shopName,
          username: store.username,
          name: store.name,
          popup: store.popup,
          appInstall: store.appInstall,
          shopifyAccessToken: store.shopifyAccessToken,
          onboardingCompleted: store.onboardingCompleted,
          onboarding_current_step: store.onboarding_current_step
        };
        const encodedUserData = JSON.stringify(userData);
        const accessUrl = `https://dingai.io/login?token=${response.token}&onboarding_completed=${store.onboardingCompleted}&user=${encodedUserData}`;
        window.location.href = accessUrl;
      }
    } catch (error) {
      console.error('Error accessing app:', error);
    }
  };

  const calculatePrice = (price, pct) => {
    if (!price) return "$0.00";
    const num = parseFloat(price.toString().replace(/[^0-9.]/g, ""));
    const d = Number(pct);
    if (!pct || isNaN(num) || isNaN(d) || d <= 0 || d > 100) return `$${num.toFixed(2)}`;
    return `$${(num * (1 - d / 100)).toFixed(2)}`;
  };

  useEffect(() => {
    const handler = (e) => {
      if (
        openIndex !== null &&
        popoverRefs.current[openIndex] &&
        !popoverRefs.current[openIndex].contains(e.target)
      ) {
        setOpenIndex(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [openIndex]);

  const filteredStores = stores.filter(store =>
    store.username.toLowerCase().includes(search.toLowerCase()) ||
    store.email.toLowerCase().includes(search.toLowerCase())
  );

  const fn_searchInput = async (value) => {
    try {
      setPage(1);
      setSearch(value)
      fetchStores(value);
    } catch (error) {
      console.error('Error accessing app:', error);
    }
  }

  return (
    <div>
      <h1 className="text-2xl font-bold mb-1">Store Search</h1>
      <p className="text-gray-700 mb-4">Search for a Store</p>

      <SearchInput
        value={search}
        onChange={(e) => fn_searchInput(e.target.value)}
        placeholder="Search by store name or URL…"
      />

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2962FF]"></div>
        </div>
      ) : (
        <>
          <StoreTable
            data={filteredStores}
            openIndex={openIndex}
            popoverRefs={popoverRefs}
            onTogglePopover={(i) => setOpenIndex((v) => (v === i ? null : i))}
            onOpenDiscount={handleOpenDiscount}
            onAccessApp={handleAccessApp}
          />

          <Pagination
            currentPage={page}
            totalPages={totalPages}
            totalEntries={totalUsers}
            onPageChange={(p) => setPage(p)}
          />
        </>
      )}

      <DiscountDialog
        isOpen={showDiscount}
        store={currentStore}
        discount={discountPct}
        onChangeDiscount={setDiscountPct}
        onClose={() => setShowDiscount(false)}
        calculatePrice={calculatePrice}
      />
    </div>
  );
}
